<template>
  <el-dialog
    title="Комментарий к отклику"
    :append-to-body="true"
    :visible="isVisible"
    :width="isMobile ? '95%' : '40%'"
    :close-on-click-modal="false"
    top="15vh"
    @close="$emit('close')"
  >
    <div v-loading="isLoading">
      <el-input
        v-model="comment"
        type="textarea"
        :rows="3"
        resize="none"
        :disabled="!isAdminOrCeoRole"
        :placeholder="
          isAdminOrCeoRole ? 'Добавьте комментарий' : 'Без комментариев'
        "
        class="comment__textarea"
      />
      <div v-if="isAdminOrCeoRole" class="comment__buttons">
        <el-button @click="$emit('close')">Закрыть</el-button>
        <el-button type="primary" @click="saveComment"> Сохранить </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
const Responses = RepositoryFactory.get('responses')

export default {
  name: 'ResponseCommentModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      comment: '',
      isLoading: false,
    }
  },
  mounted() {
    this.comment = this.response.admin_comment
  },
  methods: {
    saveComment() {
      this.isLoading = true
      const params = {
        response_id: this.response.id,
        comment: this.comment,
      }

      Responses.postResponseComment(params).then(() => {
        this.isLoading = false
        this.$emit('comment')
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.comment__buttons
  display: flex
  justify-content: flex-end
  gap: 16px
  margin-top: 16px
.comment__textarea
  word-break: break-word
  &.is-disabled ::v-deep .el-textarea__inner
    color: #000
</style>
